import { render, staticRenderFns } from "./InsuranceModal.vue?vue&type=template&id=c25db5de"
import script from "./InsuranceModal.vue?vue&type=script&lang=ts"
export * from "./InsuranceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports